import styled from 'styled-components';

export const InputWrapper = styled.div<{ err: boolean; bg?: string }>`
  padding: 10px;
  box-sizing: border-box;
  box-shadow: inset 0 0 0 ${({ err, theme }) => (err ? `2px ${theme.primary}` : `1px ${theme.altoGrey}`)};
  ${({ bg }) => (bg ? `background-color: ${bg};` : '')}
`;

export const StyledTextAreaAutoResize = styled.textarea`
  border: none;
  width: 100%;
  box-sizing: border-box;
  resize: none;
  font-size: 1em;
  font-family: inherit;
  outline: none;
  background-color: inherit;

  &::placeholder {
    color: ${({ theme }) => theme.backgroundMid};
    font-weight: 300;
    font-size: 1em;
  }
`;

export const RemainingChars = styled.div`
  font-weight: 300;
  font-size: 14px;
  padding-bottom: 5px;
`;

export const FlexLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
